import { Bajio } from "../../services/banks/Bajio";
import { Bancomer } from "../../services/banks/Bancomer"

const bankClasses = {
    bbva: Bancomer, 
    bajio: Bajio
}
export const bankFactory = (name) =>{
    const bank = bankClasses[name.toLowerCase()];
    if(!bank)   throw new Error(`El banco "${name}" no está registrado en la fábrica.`);
    return new bank()
}